<template>
  <StatCard
    :title="cardTitle"
    :value="formattedValue"
    icon="attach_money"
    icon-class="revenue-icon"
    :trend="statsComparison.trend"
    :percentage="statsComparison.percentage"
    :comparison-period="comparisonPeriod"
  />
</template>

<script>
import StatCard from "./StatCard.vue";

export default {
  name: "RevenueCard",
  components: {
    StatCard
  },
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    dateRange: {
      type: String,
      default: 'last30days'
    },
    statsComparison: {
      type: Object,
      default: () => ({ percentage: 0, trend: 'neutral' })
    },
    comparisonPeriod: {
      type: String,
      default: 'previous_period'
    }
  },
  computed: {
    formattedValue() {
      return this.formatCurrency(this.value);
    },
    cardTitle() {
      switch (this.dateRange) {
        case 'today':
          return "Today's Revenue";
        case 'yesterday':
          return "Yesterday's Revenue";
        case 'last7days':
          return "7-Day Revenue";
        case 'last30days':
          return "30-Day Revenue";
        case 'last90days':
          return "90-Day Revenue";
        default:
          return "Period Revenue";
      }
    }
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value || 0);
    }
  }
};
</script> 